// from general.js
/* global Uri dcAnalytics getTrackingLink */
// from JSP?

import { redirectToTwitterWithShortenedUrl } from './sharebarHelperFunctions.js';
import { removeHTMLTagsAndIEStyleNewLines } from '../utils/stringUtils.ts';

// TODO update the usages of this case to use non-global exports

function decorateWithOgTitle(elem, link) {
    let ogTitle = $(elem).attr('data-og-title');
    if (ogTitle) {
        ogTitle = removeHTMLTagsAndIEStyleNewLines(ogTitle);
        link = (new Uri(link)).replaceQueryParam('ogTitle', ogTitle);
    }
    return link;
}

export const onClickFacebookShare = window.onClickFacebookShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'Facebook');
    const pageSource = $(elem).attr('data-page-source');
    let link = decodeURIComponent(getTrackingLink(entityURL, 'facebook', pageSource));
    link = decorateWithOgTitle(elem, link);
    elem.href = (new Uri(elem.href)).replaceQueryParam('href', link).replaceQueryParam('link', link).toString();
};

export const onClickTwitterShare = window.onClickTwitterShare = function (elem, entityURL, shortenUrl) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'Twitter');
    const pageSource = $(elem).attr('data-page-source');
    const link = decodeURIComponent(getTrackingLink(entityURL, 'twitter', pageSource));
    if (shortenUrl) {
        redirectToTwitterWithShortenedUrl(elem.href, link);
    } else {
        elem.href = (new Uri(elem.href)).replaceQueryParam('href', link).replaceQueryParam('link', link).toString();
    }
    return false;
};

export const onClickLinkShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'directlink');
    const pageSource = $(elem).attr('data-page-source');
    let link = decodeURIComponent(getTrackingLink(entityURL, 'directlink', pageSource));
    link = decorateWithOgTitle(elem, link);
    elem.href = link;

    const tempInput = $("<input type='text'>");
    const pageURL = elem.href;

    $('body').append(tempInput);
    tempInput.val(pageURL).select();
    document.execCommand('copy');
    tempInput.remove();

    $('.copylink-popup').css('display', 'block');
    $('.mobile.share-buttons .copylink-popup').css('display', 'block');
    $('.project-url').addClass('copied');

    setTimeout(function () {
        $('.copylink-popup').css('display', 'none');
        $('.mobile.share-buttons .copylink-popup').css('display', 'none');
        $('.project-url').removeClass('copied');
    }, 2500);
};
